<template>
  <div class="reporting-analytics">
    <h2 class="text-2xl font-semibold mb-6">Reporting & Analytics</h2>

    <div v-if="!selectedReport"
     class="bg-gray-300 mb-4 shadow-lg overflow-hidden bg-primary p-2 text-xl font-semibold"
    >University-level Module Questionnaire</div>

    <div
      v-if="!selectedReport"
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6"
    >
      <div
        v-for="report in getReportByType(availableReports,1)"
        :key="report.id"
        class="bg-white shadow-lg rounded-lg overflow-hidden"
      >
        <div class="bg-primary text-white p-4">
          <h3 class="text-xl font-semibold">{{ report.title }}</h3>
        </div>
        <div class="p-6">
          <p class="text-gray-600 mb-4">{{ report.description }}</p>
          <button
            @click="selectReport(report)"
            class="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark transition duration-300"
          >
          {{report.action}}
          </button>
        </div>
      </div>
    </div>

    <div v-if="!selectedReport && (user.role != 'supervisor' || user.groups.length > 0)"
     class="bg-gray-300 mt-4 mb-4 shadow-lg overflow-hidden bg-primary p-2 text-xl font-semibold"
    >School/Academy-level Module Questionnaire</div>

    <div
      v-if="!selectedReport"
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6"
    >
      <div
        v-for="report in getReportByType(availableReports,2)"
        :key="report.id"
        class="bg-white shadow-lg rounded-lg overflow-hidden"
      >
        <div class="bg-primary text-white p-4">
          <h3 class="text-xl font-semibold">{{ report.title }}</h3>
        </div>
        <div class="p-6">
          <p class="text-gray-600 mb-4">{{ report.description }}</p>
          <button
            @click="selectReport(report)"
            class="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark transition duration-300"
          >
            View Report
          </button>
        </div>
      </div>
    </div>
    <div  v-if="!selectedReport && (user.role != 'supervisor' && (user.role != 'Staff' && user.groups.length == 0) || user.groups.length > 0)"
     class="bg-gray-300 mt-4 mb-4 shadow-lg overflow-hidden bg-primary p-2 text-xl font-semibold"
    >Download Response Data</div>

    <div
      v-if="!selectedReport"
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6"
    >
      <div
        v-for="report in getReportByType(availableReports,3)"
        :key="report.id"
        class="bg-white shadow-lg rounded-lg overflow-hidden"
      >
        <div class="bg-primary text-white p-4">
          <h3 class="text-xl font-semibold">{{ report.title }}</h3>
        </div>
        <div class="p-6">
          <p class="text-gray-600 mb-4">{{ report.description }}</p>
          <button
            @click="selectReport(report)"
            class="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark transition duration-300"
          >
            Enter
          </button>
        </div>
      </div>
    </div>


    <div v-else>
      <button
        @click="selectedReport = null"
        class="mb-4 bg-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-300 transition duration-300"
      >
        Back to Reports List
      </button>

      <component :is="selectedReport.component"></component>
    </div>
  </div>
</template>
  
  <script>
import { mapState } from "vuex";
import ModuleStaffReport from "./reports/ModuleStaffReport.vue";
import DownloadSurveyResultsModal from "./reports/DownloadSurveyResultsModal.vue";
import ResponseRateModal from "./reports/ResponseRateModal.vue";
import UniversitySurveyReport from "./reports/UniversitySurveyReport.vue";
import SchoolDepartmentSurveyReport from "./reports/SchoolDepartmentSurveyReport.vue";
export default {
  name: "ReportingAnalytics",
  components: {
    ModuleStaffReport,
    ResponseRateModal,
    DownloadSurveyResultsModal,
    UniversitySurveyReport,
    SchoolDepartmentSurveyReport,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    availableReports() {
      if (this.user.role === "supervisor") {
        return [
          {
            id: 1,
            title: "Response Rate",
            description: "Click here to view response rate.",
            component: "ResponseRateModal",
            type: 1,
            action: "View"
          },
          {
            id: 3,
            title: "University-level Module Questionnaire Report",
            description:
              "View University-level module questionnaire reports.",
            component: "UniversitySurveyReport",
            type: 1,
            action: "View Report"

          },
          // Add more reports here as they become available
        ];
      } 
      else if (this.user.role == "Staff" && this.user.groups.length == 0)
      {
        return [
          {
            id: 1,
            title: "Response Rate",
            description: "Click here to view response rate.",
            component: "ResponseRateModal",
            type: 1,
            action: "View"
          },
          {
            id: 3,
            title: "University-level Module Questionnaire Report",
            description:
              "View University MQ reports.",
            component: "UniversitySurveyReport",
            type: 1,
            action: "View Report"
          },
          {
            id: 4,
            title: "School/Academy-level Module Questionnaire Report",
            description: 'View School/Academy-level MQ reports.',
            component: "SchoolDepartmentSurveyReport",
            type: 2,
            action: "View Report"

          }]
      }
      else {
        return [
          {
            id: 1,
            title: "Response Rate",
            description: "Click here to view response rate.",
            component: "ResponseRateModal",
            type: 1,
            action: "View"

          },
          {
            id: 2,
            title: "Response Data",
            description: "Download MQ response data in Excel format.",
            component: "DownloadSurveyResultsModal",
            type: 3,
            action: "Enter"
          },
          {
            id: 3,
            title: "University-level Module Questionnaire Report",
            description:
            "View University MQ reports.",
            component: "UniversitySurveyReport",
            type: 1,
            action: "View Report"

          },
          {
            id: 4,
            title: "School/Academy-level Module Questionnaire Report",
            description: 'View School/Academy-level MQ reports.',
            component: "SchoolDepartmentSurveyReport",
            type: 2,
            action: "View Report"

          }
          // Add more reports here as they become available
        ];
      }
    },
  },
  data() {
    return {
      selectedReport: null,
      /*availableReports: [
        {
          id: 1,
          title: "School/Department Survey Report",
          description:
            "View and analyze results from school/department-level surveys.",
          component: "SchoolDepartmentSurveyReport",
        },
        {
          id: 2,
          title: "Response Data",
          description: "Download Response Data in Excel format",
          component: "DownloadSurveyResultsModal",
        },
        {
          id: 3,
          title: "University-level Module Questionnaire Report",
          description:
            "View and analyze results from university-level surveys.",
          component: "UniversitySurveyReport",
        },
        // Add more reports here as they become available
      ],*/
    };
  },
  methods: {
    getReportByType(reports, type){
      return reports.filter(x=>x.type == type)
    },  
    selectReport(report) {
      this.selectedReport = report;
    },
  },
};
</script>
  
  